//@ts-nocheck

export function QGetFSSessionUrl(): string {
  try {
    const ns = (window as any)?._fs_namespace;
    return (window as any)?.[ns]?.getCurrentSessionURL?.() ?? '';
  } catch {
    return '';
  }
}
